import { z } from 'zod'
import { id, optionalId } from './common'

/**
 * A client joins a case either personally or through one of the companies they own.
 * Ownership is verified server-side against `companies.clientId`.
 */
export const caseClientInputSchema = z.object({
  clientId: id(),
  companyId: optionalId(),
})

export type CaseClientInput = z.infer<typeof caseClientInputSchema>

export const caseClientUpdateSchema = z.object({
  companyId: optionalId(),
})

export type CaseClientUpdateInput = z.infer<typeof caseClientUpdateSchema>
